<template>
  <div class="chat-input">
    <div class="chat-textarea-wrap" :class="{'focus': focus, 'multi-line': textareaHeight > 52}">
      <textarea
        class="chat-textarea"
        rows="1"
        ref="textarea"
        v-model="question"
        maxlength="2000"
        placeholder="请描述你的问题 Enter发送，Shift + Enter 换行"
        @keydown.enter.prevent="onKeyDown"
        @input="initTextareaHeight"
        @focus="focus = true"
        @blur="focus = false"
      ></textarea>
      <yxt-tooltip
        v-if="isShowSend"
        content="暂时不能发送，请稍后再试！"
        placement="top"
        effect="light"
        popper-class="ai-box-tooltip-peak"
        :disabled="!disabled"

      >
        <div
            class="send-btn hand"
            :class="{ 'disbale-send': disabled }"
            @click="disabled ? null : $emit('send', question)"
          >
          <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" icon-class="airplane1"/>
        </div>
      </yxt-tooltip>
    </div>
  </div>
</template>

<script>
import { ICON_PATH } from '../config';
export default {
  data() {
    return {
      ICON_PATH,
      focus: false,
      question: '',
      textareaHeight: 52
    };
  },
  props: {
    disabled: {
      default: false
    }
  },
  computed: {
    isShowSend() {
      return this.question.trim();
    }
  },
  methods: {
    initTextareaHeight() {
      const ta = this.$refs.textarea;
      ta.style.height = 'auto';
      this.textareaHeight = ta.scrollHeight;
      ta.style.height = `${Math.min(this.textareaHeight, 164)}px`;
    },
    onKeyDown(event) {
      if (event.shiftKey && event.key === 'Enter') {
        this.question += '\n';
      } else if (event.key === 'Enter') {
        !this.disabled && this.isShowSend && this.$emit('send', this.question);
      }
    },
    send() {
      this.$emit('send', this.question);
    },
    clearQuestion() {
      this.question = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-input {
  width: 100%;
  .chat-textarea-wrap {
    border-radius: 26px;
    border: 1px solid transparent;
    position: relative;
    overflow: hidden;
    &.focus {
      border-color: var(--color-primary-6);
    }
    &.multi-line {
      border-radius: 12px;
    }
  }
  .chat-textarea {
    width: 100%;
    padding: 12px 62px 12px 20px;
    box-sizing: border-box;
    // border-radius: 26px;
    border: none;
    resize: none;
    line-height: 28px;
    height: 52px;
    scroll-padding-bottom: 12px;
    text-shadow: 0 4px 24px rgba(0, 0, 0, .12);
    &::-webkit-scrollbar {
      width: 6px; /* 设置滚动条宽度 */
      background: rgba(255,255,255,0);
    }
    /* 修改滚动条滑块样式 */
    &::-webkit-scrollbar-corner {
      background: rgba(144,147,153,0.3);
      border-radius: 4px;
    }
    /* 修改滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      background: rgba(144,147,153,0.3);
      border-radius: 4px;
    }

    /* 修改滚动条滑块在hover状态下的样式 */
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(144,147,153,0.3);
      border-radius: 4px;
    }
  }
  .send-btn {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: linear-gradient( 180deg, #6B90FF 0%, #436BFF 100%);
    position: absolute;
    right: 6px;
    bottom: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    &.disbale-send {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }
}
</style>
<style lang="scss">
.ai-box-tooltip-peak {
  z-index: 9999 !important;
}
</style>
